import {MetadataStructure} from '../filter/stateListResult.model';
import {BusinessProcessDimension} from './businessProcessDimension.model';

export class PanelConfigurationChartMetadata {
  id: number;
  name: string;
  metadataStructure: MetadataStructure;
  items: Array<PanelConfigurationChartMetadataItem>;

  constructor () {
    this.metadataStructure = new MetadataStructure();
    this.items = new Array<PanelConfigurationChartMetadataItem>();
  }
}

export class PanelConfigurationChartMetadataItem {
  id: number;
  legendLabel: string;
  businessProcessDimension: BusinessProcessDimension;
  domainPersistence: string;
  domain: Array<string>;

  constructor () {
    this.domain = [];
    this.businessProcessDimension = new BusinessProcessDimension();
  }
}
